'use client';

import {
	AdvancedMarker,
	useAdvancedMarkerRef,
} from '@vis.gl/react-google-maps';
import { useState } from 'react';
import { parseMap } from 'utils/parseMap';

export const MapMarker = ({ point }) => {
	const [setHasError] = useState(false);

	const coords = parseMap(point?.map || point?.fields?.map) || {
		lat: 41.3768971,
		lng: 2.1734266,
	};

	const [markerRef, _marker] = useAdvancedMarkerRef();

	return (
		// biome-ignore lint/complexity/noUselessFragments: <needs fragment or not show marker in map>
		<>
			<AdvancedMarker
				ref={markerRef}
				position={{
					lat: coords.lat,
					lng: coords.lng,
				}}
				title={point?.title || point?.fields?.title}
			>
				<img
					alt={point?.title || point?.fields?.title}
					src={
						point?.img_marker
							? point?.img_marker
							: '/resources/default-marker.svg'
					}
					width={point?.img_marker_width || 35}
					height={point?.img_marker_height || 35}
					onError={() => setHasError(true)}
				/>
			</AdvancedMarker>
		</>
	);
};
